var map = {
	"./WhatsApp.png": "4d14",
	"./fb.png": "8250",
	"./gmail.png": "1e9b",
	"./instagram.jpg": "2189",
	"./linkedin.png": "e0e8",
	"./twitter.png": "ea17",
	"./whatsapp.jpg": "5f04"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c68e";